import { customScrollMinimal } from '@toggle/design-system';
import styled from 'styled-components';

import { ErrorMessageWrapper } from '~/components/error-message-wrapper/ErrorMessageWrapper';

export const AssetOverviewRoot = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const ScrollContainer = styled.div`
  height: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  ${customScrollMinimal}
`;

export const StyledErrorWrapper = styled(ErrorMessageWrapper)`
  display: flex;
  justify-content: center;
`;

export const StyledErrorMessageWrapper = styled(ErrorMessageWrapper)`
  width: 100%;
  margin: 20px;
`;
